/* NZS-SWEEP-CONCEPT (Blake 2026-08-12/13): the Concept theme's rising-circle button hover, exact.
   The circle ENTERS from the bottom on hover, and on leave CONTINUES up and OUT the top (never
   reverses), then silently re-parks below. Pure CSS can't do a one-way conveyor across two states
   (:hover toggles reverse), so — like Concept (Motion.animate) and the Comfort Culture port
   (bindConceptFill) — a class-toggle driver carries it. All travel lives in the paired CSS block
   NZS-SWEEP-CONCEPT-0812 in nzs-base.css; this only toggles the state classes.
   v2 (2026-08-13): document-delegated pointerover/out replaces per-button binding + paced scans —
   late-mounted hosts (cart drawer contents, ajax sections) now get the exact off-animation too.
   A host is fly-bound on its first hover: park below with transition off, reflow, then sweep in.
   Touch is skipped (Concept gates on isTouch). If this asset never loads, buttons keep their prior
   keyframe behaviour — the CSS override only bites once .nzs-sweep is present. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var SEL = [
    '.nzs-satc__btn',
    '.nzs-foot-atc',
    '[id$="__cart-items"] .button:not(.button-text-link)',
    '[id$="__cart-footer"] .button:not(.button-text-link)',
    '[id$="__cart-items"] #checkout-submit',
    '[id$="__cart-items"] [name="checkout"]',
    '#main-cart-items.nzs-cart-page .nzs-cart-page__summary .button.button-solid',
    '#main-cart-items.nzs-cart-page .nzs-cart-page__shipping-estimate .button.button-solid',
    '.nzs-h2a__dss .btn',
    '.nzs-h2a__ds .hero__cta .btn',
    'a.nzs-h2a__cta'
  ].join(', ');

  var OUT_MS = 650; /* a hair past Concept's exact 0.6s travel so the repark lands after the circle clears the top */

  function repark(btn) { /* teleport the circle below with the transition off */
    btn.classList.add('is-sweep-repark');
    void btn.offsetWidth;
    btn.classList.remove('is-sweep-out', 'is-sweep-repark');
  }

  function enter(btn) {
    if (btn.__nzsT) { clearTimeout(btn.__nzsT); btn.__nzsT = 0; }
    if (!btn.classList.contains('nzs-sweep')) {
      /* fly-bind: park below invisibly BEFORE the sweep starts, so the first-ever
         hover still enters from the bottom (not from the old -126% park above) */
      btn.classList.add('nzs-sweep', 'is-sweep-repark');
      void btn.offsetWidth;
      btn.classList.remove('is-sweep-repark');
    } else if (btn.classList.contains('is-sweep-out')) {
      repark(btn); /* re-entered mid-exit: Concept always re-enters from the bottom */
    }
    btn.classList.add('is-sweep-in');
  }

  function leave(btn) {
    if (!btn.classList.contains('is-sweep-in')) return;
    btn.classList.remove('is-sweep-in');
    btn.classList.add('is-sweep-out'); /* cover -> up and out the top */
    btn.__nzsT = window.setTimeout(function () {
      btn.__nzsT = 0;
      repark(btn);
    }, OUT_MS);
  }

  function host(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    var btn = t.closest(SEL);
    if (!btn) return null;
    /* ignore moves between the button's own descendants */
    if (e.relatedTarget && btn.contains(e.relatedTarget)) return null;
    return btn;
  }

  document.addEventListener('pointerover', function (e) {
    var btn = host(e);
    if (btn) enter(btn);
  }, true);

  document.addEventListener('pointerout', function (e) {
    var btn = host(e);
    if (btn) leave(btn);
  }, true);
})();
